import React from 'react'
import AddressForm from '../address-form'
import HotSwapSummary from '../how-swap-summary'
import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(() => {
    return {
        container: {
            display: 'flex',
            alignItems: 'flex-start',
            gap: '75px'
        }
    }
})

export default function AddressServiceStep({
    selectedHotSwapLocations,
    formRef,
    setFormData
}) {
    const classes = useStyles()

    return (
        <div className={classes.container}>
            <HotSwapSummary
                selectedHotSwapLocations={selectedHotSwapLocations}
            />
            <AddressForm ref={formRef} setFormData={setFormData} />
        </div>
    )
}
